/* Roadhouse filter drawer: groups open in place instead of Dawn's slide-in submenus. */
(() => {
  const WRAPPER = '#FacetsWrapperMobile';
  let lastInputId = null;

  // Dawn's menu-drawer binds every <summary> to open a slide-in submenu and trap focus in it.
  // Stopping the click before it reaches the summary keeps the native <details> toggle only.
  document.addEventListener(
    'click',
    (event) => {
      const summary = event.target.closest('.rh-facet > summary');
      if (summary && summary.closest(WRAPPER)) event.stopPropagation();
    },
    true
  );

  // "Show all" for long lists. State sits on the <details>, which facets.js never replaces.
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-rh-more]');
    if (!button) return;
    const group = button.closest('.rh-facet');
    group.classList.add('rh-facet--expanded');
    button.setAttribute('aria-expanded', 'true');
    button.hidden = true;
    const firstHidden = group.querySelector('.rh-facet__item--more input');
    if (firstHidden) firstHidden.focus();
  });

  // Keep the group header ("Gibson, Fender") in step while the user ticks boxes.
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!input.matches || !input.matches(`${WRAPPER} .rh-facet input[type="checkbox"]`)) return;
    lastInputId = input.id;
    updateSelection(input.closest('.rh-facet'));
  });

  function updateSelection(group) {
    if (!group) return;
    const target = group.querySelector('.rh-facet__sel');
    if (!target) return;
    const labels = Array.from(group.querySelectorAll('input[type="checkbox"]:checked')).map((input) => {
      const text = input.parentElement.querySelector('.rh-facet__text');
      return text ? text.textContent.trim() : '';
    });
    target.textContent = labels.filter(Boolean).join(', ');
  }

  // facets.js swaps the value list after each change, which drops keyboard focus.
  // Put it back on the checkbox the user just used, and keep expanded lists expanded.
  function watch() {
    const wrapper = document.querySelector(WRAPPER);
    if (!wrapper || wrapper.dataset.rhWatched) return;
    wrapper.dataset.rhWatched = 'true';
    new MutationObserver(() => {
      wrapper.querySelectorAll('.rh-facet--expanded [data-rh-more]').forEach((button) => {
        button.hidden = true;
        button.setAttribute('aria-expanded', 'true');
      });
      if (!lastInputId) return;
      const active = document.activeElement;
      if (active && active !== document.body) return;
      const input = document.getElementById(lastInputId);
      lastInputId = null;
      if (input) input.focus({ preventScroll: true });
    }).observe(wrapper, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
